import type { SystemReview } from "@scoach/types";

import { api } from "../../lib/http.ts";

export const reviewsApi = {
  /** The signed-in user's own reviews + unread admin-reply count. */
  listMine: () =>
    api<{ reviews: SystemReview[]; unread: number }>("/reviews/me"),

  /** Admin: all reviews from all users + unread (new/replied) count. */
  listAll: () =>
    api<{ reviews: SystemReview[]; unread: number }>("/admin/reviews"),

  /** Lightweight badge count for the calling side. */
  unread: () => api<{ count: number }>("/reviews/unread").then((r) => r.count),

  /** Post a message into a review thread (role inferred server-side). */
  postMessage: (id: string, text: string) =>
    api<{ review: SystemReview }>(`/reviews/${id}/messages`, {
      method: "POST",
      body: { text },
    }).then((r) => r.review),

  /** Mark one review read for the calling side. */
  markRead: (id: string) =>
    api<{ ok: boolean }>(`/reviews/${id}/read`, { method: "POST", body: {} }),

  /** Admin: edit the text of an answer they posted. */
  editMessage: (id: string, msgId: string, text: string) =>
    api<{ review: SystemReview }>(`/reviews/${id}/messages/${msgId}`, {
      method: "PATCH",
      body: { text },
    }).then((r) => r.review),

  /** Admin: remove an answer they posted. */
  deleteMessage: (id: string, msgId: string) =>
    api<{ review: SystemReview }>(`/reviews/${id}/messages/${msgId}`, {
      method: "DELETE",
    }).then((r) => r.review),
};
